export { SimpleTableComponent } from './simple-table.component';
export { MySimpleTableComponent } from './my-simple-table.component';
export { SimpleTableRowDirective } from './simple-table-row.directive';
export { SimpleTableConfig } from './simple-table.config';
export * from './interface';
export { BizSimpleTableModule } from './simple-table.module';
